import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import PropTypes from "prop-types";
import logo from "../logo.svg";
import "./Error.css";

function Error({ resetErrorBoundary }) {
  const reset = () => {
    resetErrorBoundary();
    window.location("/");
  };

  return (
    <div className="App">
      <Container className="nav-content">
        <img src={logo} alt="Switch2 Logo" className="nav-logo" />
      </Container>
      <Container className="coreContent">
        <Row className="mb-4">
          <Col>
            <div className="error-message">Something went wrong</div>
          </Col>
        </Row>
        <Row>
          <Col>
            <Button onClick={reset}>Try again</Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

Error.propTypes = {
  resetErrorBoundary: PropTypes.func.isRequired,
};

export default Error;
